import { FC } from 'react';
import { Modal, Table } from 'react-bootstrap';

interface UserTableModalProps {
    user: any;
    onClose: () => void;
    show: boolean;
}

export const ReconcillationMATERIALPopUp: FC<UserTableModalProps> = ({ user, onClose, show }) => {
    return (
        <Modal
            className='modal fade'
            id='kt_modal_view_user'
            data-backdrop='static'
            tabIndex={-1}
            role='dialog'
            show={show}
            centered
            size="lg"
        >
            <div className="modal-content">
                <div className="modal-header pb-0 border-0 justify-content-end">
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={onClose}> X
                    </div>
                </div>

                <div className="modal-body scroll-y mx-5 mx-xl-18 pt-0">
                    <div className="text-center mb-13">
                        <h1 className="mb-3">Item Details</h1>
                    </div>

                    {/* Material Details Table */}
                    <div className="mb-10">
                        <Table bordered hover>
                            <thead style={{ backgroundColor: '#BFD7ED' }}>
                                <tr>
                                    <th>Category</th>
                                    <th>Item</th>
                                    <th>Grade</th>
                                    <th>Color</th>
                                    <th>Packaging</th>
                                    <th>Supplied Qty</th>
                                </tr>
                            </thead>
                            <tbody>
                                {user?.dispatchOrderDetail?.map((order: any, index: number) => (
                                    order.items.map((item: any, itemIndex: number) => (
                                        <tr key={`${index}-${itemIndex}`}>
                                            <td>{order.categoryName || 'N/A'}</td>
                                            <td>{item.itemName || 'N/A'}</td>
                                            <td>{item.grade || 'N/A'}</td>
                                            <td>{item.color || 'N/A'}</td>
                                            <td>{item.packagingType || 'N/A'}</td>
                                            <td>{item.quantity || 'N/A'}</td>
                                        </tr>
                                    ))
                                )) || (
                                        <tr>
                                            <td colSpan={6} className="text-center">No Items Found</td>
                                        </tr>
                                    )}
                            </tbody>
                        </Table>
                    </div>

                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-light"
                            onClick={onClose}
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};